export enum AutoTradeOrderAlgoTypeEnum {
    OPEN         = 1,
    CLOSE        = 2,
}
